import React from 'react'
import { IonButton, IonButtons, IonHeader, IonIcon, IonTitle, IonToolbar } from '@ionic/react'
import { chevronBackOutline } from 'ionicons/icons'
import { BaseSyntheticEvent } from 'react'
import { useHistory } from 'react-router'
import { AppRouterConstants } from '../../../components/appRouter/AppRouter.constants'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { AuthenticationService } from '../../login/services/authentication.service'
import { getUserSelector } from '../../user/selectors'
import { checkCrewList, setPersistShiftStartup } from '../store/crew.actions'
import { getClientDataImportErrorSelector } from '../../clientData/selectors/getClientDataImportError.selector'
import { checkForFailedAutoUploads, getAllPCRDocs } from '../../home/store/home.actions'

const CrewHeader: React.FC = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const user = useSelector(getUserSelector)
  const history = useHistory()
  const clientDataImportError = useSelector(getClientDataImportErrorSelector)
  const nextOnClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    dispatch(checkForFailedAutoUploads())
    dispatch(setPersistShiftStartup())
    dispatch(checkCrewList())
    dispatch(getAllPCRDocs())
    history.push({
      pathname: AppRouterConstants.HOME_ROUTE,
      state: { showToast: true },
    })
  }

  const onBackClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    AuthenticationService.doLogout(user, dispatch)
    history.push(AppRouterConstants.INDEX_ROUTE)
  }

  return (
    <IonHeader>
      <IonToolbar color='light'>
        <IonButtons slot='start'>
          <IonButton data-testid='Back' onClick={onBackClick} color='primary-alt'>
            <IonIcon icon={chevronBackOutline} />
            {t('common.buttons.Logout')}
          </IonButton>
        </IonButtons>
        {!clientDataImportError && (
          <IonButtons slot='end'>
            <IonButton data-testid='Next' onClick={nextOnClick} color='primary-alt'>
              {t('common.buttons.Next')}
            </IonButton>
          </IonButtons>
        )}
        <IonTitle>{t('shift.ShiftStartup')}</IonTitle>
      </IonToolbar>
    </IonHeader>
  )
}

export default CrewHeader
